import React from "react";

import { Box, TableHead, TableRow } from "@mui/material";
import { Button, TableCellBody, TableCellHead } from "@src/components";

import { ReactComponent as ArrowDownIcon } from "@src/assets/icons/arrowDown.svg";

interface TopPositionsTableHeaderProps {
  data: any[];
  onSort: (field: string) => void;
}

export const TopPositionsTableHeader: React.FC<TopPositionsTableHeaderProps> = (
  props
) => {
  const { data, onSort } = props;

  const [currentSortField, setCurrentSortField] =
    React.useState<string>("orders");

  const handleSort = (sortField: string) => {
    onSort(sortField);
    setCurrentSortField(sortField);
  };

  return (
    <TableHead>
      {data.map((cell, index) => {
        return (
          <TableCellBody key={cell.id} align={"left"}>
            <Button
              variant="contained"
              onClick={() => {
                index > 1 ? handleSort(cell.sortName) : null;
              }}
              color="neutral"
              endIcon={
                index > 1 ? (
                  currentSortField === cell.sortName ? (
                    <ArrowDownIcon style={{ transform: "rotate(180deg" }} />
                  ) : (
                    <ArrowDownIcon />
                  )
                ) : (
                  <Box />
                )
              }
            >
              {cell.content}
            </Button>
          </TableCellBody>
        );
      })}
    </TableHead>
  );
};